import React from 'react';
import { Route, Switch } from 'react-router';

import TutoringCompanies from './TutoringCompanies';
import CreateTutoringCompany from './CreateTutoringCompany';
import EditTutoringCompany from './EditTutoringCompany';

export default [
  <Route key="admin-tutoring-company" path="/admin/tutoring-company">
    <Switch>
      <Route
        exact
        title="Tutoring Companies"
        path="/admin/tutoring-company"
        component={TutoringCompanies}
      />
      <Route
        exact
        title="Tutoring Companies"
        path="/admin/tutoring-company/create"
        component={CreateTutoringCompany}
      />
      <Route
        exact
        title="Tutoring Company"
        path="/admin/tutoring-company/:nodeId"
        component={EditTutoringCompany}
      />
    </Switch>
  </Route>,
];



// WEBPACK FOOTER //
// ./src/modules/admin/company/TutoringCompanyRoutes.js